import { render, staticRenderFns } from "./StaffTotal.vue?vue&type=template&id=5149a0b6&"
import script from "./StaffTotal.vue?vue&type=script&lang=js&"
export * from "./StaffTotal.vue?vue&type=script&lang=js&"
import style0 from "./StaffTotal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports